// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9FEZv","col":"styles_col__13hOL"};